import { IFtthOffer } from "@nju/data-access-portal-offers";
import { BlockText, Separator, Text } from "@nju/ui";
import { formatPrice } from "@nju/utils";

interface IHeadingProps {
  isSfh: boolean | undefined;
  offer: IFtthOffer;
}

export function HeadingFtth({ isSfh, offer }: IHeadingProps) {
  return (
    <>
      <Separator size="xs" tone="invisible" />
      <BlockText>{`nju światłowód do ${offer.downloadFullText}`}</BlockText>
      <Separator size="xxs" tone="invisible" />
      <BlockText testId="recurring-price">
        <Text size="keyS" weight="bold">
          {formatPrice(offer.totalRecurringPrice, false)}
        </Text>{" "}
        zł miesięcznie
      </BlockText>
      {isSfh && (
        <>
          <Separator size="xxs" tone="invisible" />
          <BlockText size="s" tone="neutral">
            + {offer.ftthSfhPrice && formatPrice(offer.ftthSfhPrice, false)} zł
            miesięcznie
            <Separator size="none" tone="invisible" />
            dopłata za internet w budynku jednorodzinnym
          </BlockText>
        </>
      )}
      <Separator size="s" thickness="medium" tone="accent" />
    </>
  );
}
